import { render, staticRenderFns } from "./VMVHero.vue?vue&type=template&id=03d87934&scoped=true&"
import script from "./VMVHero.vue?vue&type=script&lang=js&"
export * from "./VMVHero.vue?vue&type=script&lang=js&"
import style0 from "./VMVHero.vue?vue&type=style&index=0&id=03d87934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d87934",
  null
  
)

export default component.exports